import { Editor } from "@tiptap/core";

export default function SimpleBubbleMenu({show = true, editor}: {show?: boolean; editor: Editor}) {
  if (!show)
    return null

  return <div className="bg-black text-white p-0.2 rounded-xl flex flex-row gap-0.5 select-none">
    <button className="flex" onClick={(e) => { e.preventDefault(); editor.commands.toggleBlockquote() }}><img src="/images/simple-editor/quote-white.svg" /></button>
    <button className="flex" onClick={(e) => { e.preventDefault(); editor.commands.toggleBold() }}><img src="/images/simple-editor/bold-white.svg" /></button>
    <button className="flex" onClick={(e) => { e.preventDefault(); editor.commands.toggleItalic() }}><img src="/images/simple-editor/italic-white.svg" /></button>
    <button className="flex" onClick={(e) => { e.preventDefault(); editor.commands.toggleUnderline() }}><img src="/images/simple-editor/underlined-white.svg" /></button>
    <button className="flex" onClick={(e) => { e.preventDefault(); editor.commands.toggleBulletList() }}><img src="/images/simple-editor/list-bulleted-white.svg" /></button>
    <button className="flex" onClick={(e) => { e.preventDefault(); editor.commands.toggleOrderedList() }}><img src="/images/simple-editor/list-numbered-white.svg" /></button>
  </div>
}
